import React, { Fragment, useEffect, useState } from 'react';
import AppContext from '../AppContext';
import { Button, CircularProgress, Grid, InputLabel, TextField, Typography } from '@material-ui/core';
import Select from 'react-select';
import { useTranslation } from 'react-i18next';
import PaddedGrid from '../components/PaddedGrid';
import APIService from '../services/APIService';
import Loading from '../components/Loading';
import i18next from 'i18next';

const customStyles = {
    control: (provided) => ({
        ...provided,
        fontFamily: "Roboto, sans-serif",
    }),
    menu: (provided) => ({
        ...provided,
        fontFamily: "Roboto, sans-serif",
    }),
    option: (provided) => ({
        ...provided,
        fontFamily: "Roboto, sans-serif",
    }),
};

const FeedbackReporting = () => {
    const { t } = useTranslation();
    const [errors, setErrors] = useState([]);
    const [loading, setLoading] = useState(false);
    const [generating, setGenerating] = useState(false);
    const [restaurants, setRestaurants] = useState([]);
    const [selectedRestaurants, setSelectedRestaurants] = useState([]);
    const [from, setFrom] = useState(null);
    const [to, setTo] = useState(null);

    useEffect(() => {
        setLoading(true);
        if (!AppContext.isUser()) {
            APIService.getRestaurants().then((restaurants) => {
                setRestaurants(restaurants.sort(function (a, b) {
                    if (a.name < b.name) {
                        return -1;
                    }
                    if (a.name > b.name) {
                        return 1;
                    }
                    return 0;
                }));
            });
        }
        setLoading(false);
    }, []);

    const handleExport = () => {
        setGenerating(true);
        APIService.exportFeedbackReport(selectedRestaurants, from, to, i18next.language || 'fi').then(() => {
            setGenerating(false);
        }).catch((error) => {
            console.log('error');
            setGenerating(false);
            setErrors(error.message);
        });
    };

    if (loading) {
        return <Loading />;
    }

    return (
        <div style={{ maxWidth: '800px' }}>
            <PaddedGrid>
                <Grid item xs={12}>
                    <Typography variant="title">{t('Palauteraportointi')}</Typography>
                </Grid>
                <Grid item xs={12}>
                    <Typography variant='title'>{t('Generoi raportti')}</Typography>
                </Grid>
                {!AppContext.isUser() &&
                    <Grid item xs={12}>
                        <Grid style={{ width: '100%' }}>
                            <InputLabel shrink style={{ fontSize: '12px' }}>{t('Ravintola')}</InputLabel>
                            <Select
                                options={restaurants.map(r => ({ value: r.id, label: r.name }))}
                                isMulti
                                isClearable
                                closeMenuOnSelect={false}
                                styles={customStyles}
                                placeholder=""
                                onChange={(selectedOptions) => setSelectedRestaurants(selectedOptions ? selectedOptions.map(option => option.value) : [])}
                                value={restaurants.filter(r => selectedRestaurants.includes(r.id)).map(r => ({ value: r.id, label: r.name }))}
                            />
                        </Grid>
                    </Grid>
                }
                <Grid item xs={6}>
                    <TextField
                        fullWidth
                        type="date"
                        error={errors.includes('from')}
                        label={t('Päivämäärästä')}
                        onChange={(e) => {
                            setErrors(errors.filter((error) => error !== 'from'));
                            setFrom(e.target.value);
                        }}
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />
                </Grid>
                <Grid item xs={6}>
                    <TextField
                        fullWidth
                        type="date"
                        error={errors.includes('to')}
                        label={t('Päivämäärään')}
                        onChange={(e) => {
                            setErrors(errors.filter((error) => error !== 'to'));
                            setTo(e.target.value);
                        }}
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />
                </Grid>
                <Grid item xs={12}>
                    <Button variant="raised" color="primary" onClick={handleExport} disabled={generating}>
                        {t('Generoi')}
                        {generating && <CircularProgress size={16} color="inherit" style={{ marginLeft: '1rem' }} />}
                    </Button>
                </Grid>
            </PaddedGrid>
        </div >
    );
};

export default (FeedbackReporting);



// WEBPACK FOOTER //
// ./resources/assets/js/containers/FeedbackReporting.js